import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=d4844ddc&scoped=true&"
import script from "./SearchItem.vue?vue&type=script&lang=js&"
export * from "./SearchItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=d4844ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4844ddc",
  null
  
)

export default component.exports